import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';
import { EnvironmentCheckService, EnvironmentType } from '@fleet-beat/core';

@Injectable()
export class EnvironmentGuard implements CanActivate {
  constructor(private environmentCheckService: EnvironmentCheckService) {}

  /* eslint-disable-next-line @typescript-eslint/no-unused-vars */
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const environments: EnvironmentType[] = route.data['environments'];
    return this.environmentCheckService.check(environments);
  }
}
